<template>
    <div class="myCaseBox">
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="我的案件" name="first">
                <myCase v-if="activeName === 'first'"></myCase>
            </el-tab-pane>
            <el-tab-pane label="被申请案件" name="second">
                <petitionedCase v-if="activeName === 'second'"></petitionedCase>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    import myCase from './components/myCase';
    import petitionedCase from './components/petitionedCase';

    export default {
        name: 'lawCase',
        data() {
            return {
                activeName: 'first'
            };
        },
        components:{
            myCase,
            petitionedCase
        },
        methods:{
            updateType () {
                let type = this.$route.query.type
                // 判断type的值，更改activeName的值
                //我申请的仲裁案件
                if (type === 'first') {
                    sessionStorage.setItem('currentTab3', 'first')
                    return this.activeName = 'first'
                    //    我发起的
                }else if (type === 'second') {
                    sessionStorage.setItem('currentTab3', 'second')
                    return this.activeName = 'second'
                }
            },
            handleClick(tab, event){
                sessionStorage.setItem('currentTab3', tab.name)
            }
        },
        created() {
            this.updateType()
            let name = sessionStorage.getItem('currentTab3')
            // 判断是否存在currentTab，即tab页之前是否被点击切换到别的页面
            if(name){
                this.activeName = name
            }
        },
    };
</script>

<style scoped>
    .myCaseBox{
        padding: 20px;
        background-color: #fff;
        border-radius: 5px;
    }
    /deep/ .el-tabs__nav-wrap::after{
        background-color: transparent;
    }
    /deep/.el-tabs__item{
        padding: 0px 30px;
    }
</style>
